import styled from 'styled-components';

interface ContainerProps {
};

const Container = styled.div<ContainerProps>`
`

export default Container;
